import { useState, useEffect } from "react";
import { Box, Fade, List, ListItem } from "@mui/material";
import { useContext } from "react";
import { Link } from "react-router-dom";

import PageRoutes from "../Config/PageRoutes";
import MenuContext from "../store/menu-context";
import classes from "../Style/Menu.scss";
import ScientificReport from "../Components/ScientificReport";
import SideBarLineSvg from "./SideBarLineSvg";
import Logo from "./Logo";

const Menu = (props) => {
  const ctx = useContext(MenuContext);
  const handleSecondaryMenuClick = (index, id) => {
    ctx.updateContext(index, false);
  };

  const [key, setKey] = useState(
    props.path.indexOf(PageRoutes.CHAPTER_TWO) > -1 ? 2 : 1
  );

  //onClick change state to active, execution per key
  const setSideBar = (activeKey) => {
    if (key === activeKey) {
      return;
    }
    setKey(props.path.indexOf(PageRoutes.CHAPTER_TWO) > -1 ? 1 : 2);
  };

  const path = props.path;
  useEffect(() => {
    if (path.indexOf(PageRoutes.CHAPTER_TWO) > -1) {
      setKey(2);
    } else if (path.indexOf(PageRoutes.IMPORTANT_CONCEPTS) > -1) {
      setKey(3);
    } else {
      setKey(1);
    }
  }, [path]);

  return (
    <Box className="menuWrapper">
      {/* <Link to={PageRoutes.ROOT}>Home</Link> */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        marginLeft="15px"
        marginBottom="1rem"
      >
        <Link to={PageRoutes.CHAPTER_ONE}>
          <Box
            sx={{
              display: "flex",
            }}
            onClick={() => setSideBar(1)}
          >
            <Logo />
          </Box>
        </Link>
      </Box>
      <Box alignItems="center" justifyContent="center">
        {<ScientificReport />}
      </Box>
      <Box className="innerMenu">
        <ul>
          <li>
            <Link to={PageRoutes.CHAPTER_ONE}>
              <Box sx={{ display: "flex" }}>
                <Box
                  className={
                    props.path.indexOf(PageRoutes.CHAPTER_ONE) > -1 ||
                    props.path.indexOf("commodity") > -1
                  }
                ></Box>
                <Box
                  onClick={() => setSideBar(1)}
                  className={
                    key === 2
                      ? "menuItem"
                      : key === 1
                      ? " menuItem active"
                      : "simpleLink"
                  }
                >
                  <Box marginLeft="12px">
                    <SideBarLineSvg />
                  </Box>
                  <span>CHAPTER ONE</span>

                  <h3
                    className={
                      key === 2 ? "underline" : key === 1 ? "" : "simpleLink"
                    }
                  >
                    EU-coordinated multiannual control programme
                  </h3>
                </Box>
              </Box>
            </Link>
          </li>

          <li>
            <Link to={PageRoutes.CHAPTER_TWO}>
              <Box sx={{ display: "flex" }}>
                <Box
                  className={props.path.indexOf(PageRoutes.CHAPTER_TWO) > -1}
                ></Box>
                <Box
                  onClick={() => setSideBar(2)}
                  className={
                    key === 1
                      ? "menuItem"
                      : key === 2
                      ? " menuItem active"
                      : "simpleLink"
                  }
                >
                  <Box marginLeft="12px">
                    <SideBarLineSvg />
                  </Box>

                  <span>CHAPTER TWO</span>
                  <h3
                    className={
                      key === 2 ? "" : key === 1 ? "underline" : "simpleLink"
                    }
                  >
                    Multiannual national <br />
                    control programme
                  </h3>
                </Box>
              </Box>
            </Link>
          </li>
          <li
            className={
              key === 1 ? "slide" : key === 2 ? "slide active" : "test"
            }
          ></li>
        </ul>

        {/* <Fade in={props.path === PageRoutes.CHAPTER_TWO}>
					<List className='secondaryMenu'>
						<ListItem>
							<Box sx={{ display: 'flex', color: 'red !important' }}>
								<Box className='secondaryActiveWrapper'>
									<Box
										className={
											ctx.index === 0
												? 'secondaryActiveWrapperInner secondaryActiveWrapperInnerActive'
												: 'secondaryActiveWrapperInner'
										}
									></Box>
								</Box>
								<Link onClick={handleSecondaryMenuClick.bind(this, 0)} to='#'>
									Section I: Geospatial
								</Link>
							</Box>
						</ListItem>
						<ListItem>
							<Box sx={{ display: 'flex' }}>
								<Box className='secondaryActiveWrapper'>
									<Box
										className={
											ctx.index === 1
												? 'secondaryActiveWrapperInner secondaryActiveWrapperInnerActive'
												: 'secondaryActiveWrapperInner'
										}
									></Box>
								</Box>
								<Link onClick={handleSecondaryMenuClick.bind(this, 1)} to='#'>
									Section II: Residue level
								</Link>
							</Box>
						</ListItem>
						<ListItem>
							<Box sx={{ display: 'flex' }}>
								<Box className='secondaryActiveWrapper'>
									<Box
										className={
											ctx.index === 2
												? 'secondaryActiveWrapperInner secondaryActiveWrapperInnerActive'
												: 'secondaryActiveWrapperInner'
										}
									></Box>
								</Box>
								<Link onClick={handleSecondaryMenuClick.bind(this, 2)} to='#'>
									Section III: Food product groups
								</Link>
							</Box>
						</ListItem>
					</List>
				</Fade> */}
      </Box>
    </Box>
  );
};

export default Menu;
